var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"align-content":"center","justify":"center"}},[_c('v-col',{staticClass:"mt-12",attrs:{"cols":"12","md":"8"}},[_c('h1',[_vm._v("Page not found")]),_c('v-btn',{attrs:{"color":"primary","to":"/"}},[_vm._v("Return Home")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }